import Tooltip from "@mui/material/Tooltip"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

import Row from "../../../common/components/Row"
import CandidateAvatar from "./CandidateAvatar"

export default function MeetingAttendeesStack({
  attendees,
  avatarSize = "32px",
  fontSize = "16px",
}) {
  const first2Attendees = attendees.slice(0, 2)
  const extraAttendeeCount = attendees.slice(2).length

  return (
    <Row sx={{ position: "relative", height: avatarSize, width: "84px" }}>
      {first2Attendees.map((attendee, i) => (
        <Tooltip title={attendee.candidate_name} key={attendee.id}>
          <CandidateAvatar
            key={i}
            size={avatarSize}
            fontSize={fontSize}
            candidate={attendee}
            rootSX={{
              position: "absolute",
              top: 0,
              left: i * 24,
              outline: i === 0 ? "none" : `2px solid white`,
            }}
          />
        </Tooltip>
      ))}
      {extraAttendeeCount === 0 ? null : (
        <ExtraAttendeesRow>
          <Typography
            variant="body2"
            sx={{ color: "colors.gray600", fontWeight: 600 }}
          >
            +{extraAttendeeCount}
          </Typography>
        </ExtraAttendeesRow>
      )}
    </Row>
  )
}

const ExtraAttendeesRow = styled(Row)(({ theme }) => ({
  justifyContent: "center",
  alignItems: "center",
  width: "32px",
  aspectRatio: "1/1",
  backgroundColor: theme.palette.colors.gray100,
  outline: `2px solid white`,
  borderRadius: "25px",
  position: "absolute",
  left: "48px",
}))
